import { Modal } from "react-bootstrap"
import { UserContext } from "./UserContext";
import { useContext, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import CustomSelect from "../utilities/Reusable/CustomSelect";

export const ModalForm=({mode})=>{
    const {error,setError, showCreateModal, setShowCreateModal, showEditModal, setShowEditModal, handleSubmit,handleUpdate,handleCloseCreateModal,
        handleOpenCreateModal,handleOpenEditModal,handleCloseEditModal,handleLogout,handleOpenUpdateModal,handleChange,formData,setFormData,clearFormData } = useContext(UserContext);
    const handleClose = mode === 'create' ? handleCloseCreateModal : handleCloseEditModal;
     const show = mode === 'create' ? showCreateModal : showEditModal;
     
  const [showCPassword, setShowCPassword] = useState(false);
  const userAdminOptions=[{label:"Yes",value:"Y"},{label:"No",value:"N"}];
  const userTypeOptions=[{label:"Clinic",value:"CLINIC"},{label:"Patient",value:"PATIENT"}];

     const handleAction =
     mode === 'create'
       ? (e) => handleSubmit(e)
       : (e) => handleUpdate(e,formData.userName);
    return(
    <>
    <Modal show={show} onHide={true} size="lg" backdrop="static" centered>
        <form onSubmit={handleAction}>
            <div className="container-fluid p-4">
                <div className="modal-header-custom mb-2">
                    <h5 className="">{mode === 'create' ? 'Create User' : 'Update User'}</h5>
                    <button type="button" className="btn-close mb-2" aria-label="Close" onClick={handleClose}></button>
                </div>
                <div className="row mt-3 modal-grid">
                    <div className="col left-column">
                        <div className="">
                            <label htmlFor="uname" className="form-label">User Name</label>
                            <input type="text" className="form-control" id="uname" value={formData.userName} name="userName" disabled={mode!=='create'?true:false} onChange={handleChange} required autoComplete="off"/>
                        </div>
                        <div className="mt-3 position-relative">
                            <label htmlFor="upass" className="form-label">User Password</label>
                            <input type={showCPassword ? "text" : "password"} className="form-control" id="upass" value={formData.userPassword} name="userPassword" onChange={handleChange} required autoComplete="off"/>
                            <span className="eye-icon" onClick={() => setShowCPassword(!showCPassword)} >{showCPassword ? <FaEyeSlash /> : <FaEye />}</span>
                        </div>
                    </div>

                    <div className="col">
                        <div className="">
                            <label htmlFor="" className="form-label">User type</label>
                            <CustomSelect
                                id="userType"
                                name="userType"
                                valueKey="value"
                                labelKey="label"
                                data={userTypeOptions}
                                value={formData.userType || ''}
                                onChange={handleChange}
                                // isDisabled={notEditMode}
                                placeholder="Select an option"
                                />
                        </div>
                        <div className="mt-3">
                            <label htmlFor="" className="form-label">User Admin</label>
                            <CustomSelect
                                id="userAdmin"
                                name="userAdmin"
                                valueKey="value"
                                labelKey="label"
                                data={userAdminOptions}
                                value={formData.userAdmin || ''}
                                onChange={handleChange}
                                // isDisabled={notEditMode}
                                placeholder="Select an option"
                                />
                        </div>
                    </div>
                    <div className="d-flex gap-4">                        
                        <button className="btn btn-secondary w-100 mt-3" type="button"  onClick={handleClose}>Cancel</button>
                        <button className="btn btn-primary w-100 mt-3" type="submit" style={{background: 'rgba(9, 139, 190, 1)',borderColor: 'rgba(9, 139, 190, 1)'}}>{mode==='create'?'Submit':'Update'}</button>
                    </div>
                </div>
                {/* {error && <p className="text-danger text-center mt-3">{error}</p>} */}
            </div>
        </form>
    </Modal>
    <style>
        {`
          .modal-header-custom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px dotted #D5D5D5;
          }

          .modal-grid {
            display: flex;
          }

          /* Make mobile responsive */
          @media (max-width: 768px) {
            .modal-grid {
              flex-direction: column;
            }
            .left-column {
              border-right: none !important;
              margin-bottom: 10px;
            }
          }

          .left-column {
            border-right: 1px solid #D5D5D5;
          }

          .eye-icon {
            position: absolute;
            right: 10px;
            top: 38px;
            cursor: pointer;
            color: #000000B2;
          }

          .form-control {
            min-height: 40px;
            height: 38px;
            border-radius: 4px;
          }

          .form-control:focus,
          .form-control:hover {
            border-color: #9ee4ff;
            box-shadow: 0 0 0 1px #9ee4ff;
          }
        `}
    </style>
    </>
)
}